export default __webpack_public_path__ + "static/media/new_logo.8c8e5a2a.png";